import {
  Box,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
import googleIconSvg from "../../../src/Assets/Images/Vectors/googleIcon.svg";
import RtButton from "../Global/Button/index";
import { useAuth } from "../../context/AuthContext";

import { LoginUIStateConsumer, AuthConsumer } from "../../context/AuthContext";
import {
  ArrowForward,
  ArrowForwardIos,
  MarkAsUnread,
} from "@mui/icons-material";
import { constrainPoint } from "@fullcalendar/core";

const SignUpForm = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  //get current user, error and signUpNewUser method from useAuth
  const { signUpNewUser, signInUserWithGoogle } = useAuth();

  // stepper
  const steps = ["Company Email", "Username & Password", "Contact", "Confirm"];

  const [activeStep, setActiveStep] = useState(0);
  const [inputError, setInputError] = useState(false);

  const handleNext = (_element) => {
    let _input = document.querySelectorAll(".register-container .register-tab");

    for (let i = 0; i < steps.length; i++) {
      if (activeStep === i) {
        let currentInputs = _input[i].querySelectorAll("input");
        for (let a = 0; a < currentInputs.length; a++) {
          if (currentInputs[a].value.length < 3) {
            setInputError(true);
            return false;
          } else if (currentInputs[a].value.length > 3) {
            setInputError(false);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            if (activeStep === steps.length - 2) {
              return handleFormSubmit;
            }
            return true;
          }
        }
      }
    }
  };

  const handleFormSubmit = (values) => {
    console.log(values, "Values");
    const email = values.email;
    const password = values.password;
    const company_name = values.org_name;
    const first_name = values.password;
    const last_name = values.password;
    const phone_number = values.contact;
    const country = values.country;
    const city = values.city;
    const address = values.address;
    signUpNewUser(email, password, first_name, last_name);
    //  push the rest of the data to the userprofile
    // saveUserProfile()
  };

  return (
    <AuthConsumer>
      {(authContext) => {
        return (
          <LoginUIStateConsumer>
            {(contextValue) => {
              const { logInUIActive, setUIActive } = contextValue;
              return (
                <Box
                  className="register-container"
                  display={logInUIActive ? "block" : "none"}
                >
                  <Box
                    textAlign={"center !important"}
                    display={logInUIActive === true ? "flex" : "none"}
                    flexDirection={"column"}
                    alignContent={"flex-start"}
                    sx={{
                      transition: "0.8s all ease-in-out",
                    }}
                  >
                    <h2 className="title mb-2">
                      Fill up the form and let's sign you up!
                    </h2>
                    <p className="p-text text-align-left mb-4">
                      Please enter your details to continue.
                      <strong className=""> No Credit Card Required.</strong>
                    </p>
                    {/* Set active step  */}
                    <Stepper activeStep={activeStep}>
                      {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};

                        return (
                          <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                          </Step>
                        );
                      })}
                    </Stepper>
                    {/* Confirm last step */}
                    {activeStep === steps.length ? (
                      <Box>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                          Your form has been submitted successfully. Email
                          verfication will be sent to you{" "}
                          <span className="circle bg-blue">
                            <MarkAsUnread />
                          </span>
                        </Typography>
                        <Box
                          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                        ></Box>
                      </Box>
                    ) : (
                      // Steps here

                      <Box>
                        {/* Registeration forms here */}

                        <Box>
                          <Formik
                            onSubmit={handleFormSubmit}
                            initialValues={initialValues}
                            validationSchema={checkoutSchema}
                          >
                            {({
                              values,
                              errors,
                              touched,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                            }) => (
                              <form onSubmit={handleSubmit}>
                                <Box
                                  mt={"1.5rem"}
                                  display="grid"
                                  gap="10px"
                                  sx={{
                                    "& > div": {
                                      gridColumn: isNonMobile
                                        ? undefined
                                        : "span 4",
                                    },
                                  }}
                                >
                                  <Box
                                    display={`${
                                      activeStep !== 0 ? "none" : "flex"
                                    }`}
                                    className="register-tab"
                                  >
                                    {/* Email Address */}
                                    <TextField
                                      placeholder="some@one.com"
                                      className="input-field"
                                      fullWidth
                                      variant="filled"
                                      type="text"
                                      label="Company Email"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.email}
                                      name="email"
                                      error={!!touched.email && !!errors.email}
                                      helperText={touched.email && errors.email}
                                      sx={{
                                        gridColumn: "span 2",
                                      }}
                                    />

                                    <TextField
                                      placeholder="Organization Name"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="text"
                                      label="Organization Name"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.org_name}
                                      name="org_name"
                                      error={
                                        !!touched.org_name && !!errors.org_name
                                      }
                                      helperText={
                                        touched.org_name && errors.org_name
                                      }
                                      sx={{ gridColumn: "span 2" }}
                                    />
                                  </Box>
                                  {/* End password field */}
                                  {/* Bio field */}
                                  <Box
                                    className="register-tab"
                                    width={"100%"}
                                    display={`${
                                      activeStep === 1 ? "block" : "none"
                                    }`}
                                  >
                                    <TextField
                                      placeholder="First Name e.g John"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="text"
                                      label="First Name"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.first_name}
                                      name="first_name"
                                      error={
                                        !!touched.first_name &&
                                        !!errors.first_name
                                      }
                                      helperText={
                                        touched.first_name && errors.first_name
                                      }
                                      sx={{ gridColumn: "span 1" }}
                                    />
                                    <TextField
                                      placeholder="Second Name e.g Doe"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="text"
                                      label="Second Name"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.second_name}
                                      name="second_name"
                                      error={
                                        !!touched.second_name &&
                                        !!errors.second_name
                                      }
                                      helperText={
                                        touched.second_name &&
                                        errors.second_name
                                      }
                                      sx={{ gridColumn: "span 1" }}
                                    />
                                    <TextField
                                      placeholder="Password"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="password"
                                      label="Password"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.password}
                                      name="password"
                                      error={
                                        !!touched.password && !!errors.password
                                      }
                                      helperText={
                                        touched.password && errors.password
                                      }
                                      sx={{ gridColumn: "span 1" }}
                                    />

                                    {/* Repeat Password */}
                                    <TextField
                                      placeholder="Confirm Password"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="password"
                                      label="Confirm Password"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      name="password2"
                                      value={values.password2}
                                      error={
                                        !!touched.password2 &&
                                        !!errors.password2
                                      }
                                      helperText={
                                        touched.password2 && errors.password2
                                      }
                                      sx={{ gridColumn: "span 1" }}
                                    />
                                  </Box>
                                  {/* End bio field */}
                                  {/* Phone and Country */}
                                  <Box
                                    className="register-tab"
                                    display={`${
                                      activeStep === 2 ? "block" : "none"
                                    }`}
                                  >
                                    <TextField
                                      placeholder="Telephone e.g +233 12 345 6789"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="number"
                                      label="Company Telephone"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.contact}
                                      name="contact"
                                      error={
                                        !!touched.contact && !!errors.contact
                                      }
                                      helperText={
                                        touched.contact && errors.contact
                                      }
                                      sx={{ gridColumn: "span 1" }}
                                    />
                                    <TextField
                                      placeholder="Company Address"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="text"
                                      label="Company Address"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.address}
                                      name="address"
                                      error={
                                        !!touched.address && !!errors.address
                                      }
                                      helperText={
                                        touched.address && errors.address
                                      }
                                      sx={{ gridColumn: "span 1" }}
                                    />
                                    <TextField
                                      placeholder="Which country is your company located. e.g Ghana"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="text"
                                      label="Country"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.country}
                                      name="country"
                                      error={
                                        !!touched.country && !!errors.country
                                      }
                                      helperText={
                                        touched.country && errors.country
                                      }
                                      sx={{ gridColumn: "span 1" }}
                                    />
                                    <TextField
                                      placeholder="City/Town. e.g Accra"
                                      fullWidth
                                      className="input-field"
                                      variant="filled"
                                      type="text"
                                      label="City/Town"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.city}
                                      name="city"
                                      error={!!touched.city && !!errors.city}
                                      helperText={touched.city && errors.city}
                                      sx={{ gridColumn: "span 1" }}
                                    />
                                  </Box>
                                  {/* End phone and Country */}
                                  {/* Terms and conditions */}
                                  <Box
                                    className=" float-end register-tab"
                                    display={`${
                                      activeStep === steps.length - 1
                                        ? "block"
                                        : "none"
                                    }`}
                                  >
                                    <Typography>
                                      Before clicking on the confirm button,
                                      please make sure to
                                      <span className="text-danger bold">
                                        <Link to={"/terms_and_conditions"}>
                                          read and accept all our terms and
                                          conditions.
                                        </Link>
                                      </span>
                                    </Typography>
                                    <input
                                      // required
                                      type="checkbox"
                                      name="tmc_check"
                                      id="tmc_check"
                                    />
                                  </Box>
                                  {/* End terms and conditions */}
                                </Box>

                                <Box display="flex" mt="50px">
                                  <button
                                    type={
                                      activeStep === steps.length - 1
                                        ? "submit"
                                        : "button"
                                    }
                                    className="auth-btn btn center"
                                    onClick={handleNext}
                                  >
                                    {activeStep === steps.length - 1
                                      ? "Confirm"
                                      : "Continue"}

                                    <span className="flex center">
                                      <ArrowForwardIos />
                                    </span>
                                  </button>
                                </Box>
                                <Box
                                  mt={"1.5rem"}
                                  display={`${
                                    activeStep > 0 ? "none" : "block"
                                  }`}
                                >
                                  <Typography
                                    className="p-text"
                                    display={"flex"}
                                    justifyContent="center"
                                  >
                                    Already having an account?
                                    <span
                                      style={{
                                        marginLeft: "4px",
                                        color: "lightgreen !important",
                                      }}
                                    >
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          return setUIActive(!logInUIActive);
                                        }}
                                      >
                                        Click here to Login
                                      </Link>
                                    </span>
                                  </Typography>
                                </Box>
                              </form>
                            )}
                          </Formik>
                        </Box>
                        {/* End registeration forms */}
                      </Box>
                    )}
                    {/*  */}
                    <Box display={`${activeStep > 0 ? "none" : "block"}`}>
                      {/* or register with google */}
                      <Box className="divider mt-4">
                        <hr />
                        <Typography>or register with</Typography>
                        <hr />
                      </Box>
                      <Box className="sign-in__with-google" mb={"2rem"}>
                        <RtButton
                          iconSrc={googleIconSvg}
                          text="Continue with Google"
                          textColor={"#123"}
                          borderColor={"#123"}
                          borderRadius={"5px"}
                          onClickAction={() => {
                            return signInUserWithGoogle();
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              );
            }}
          </LoginUIStateConsumer>
        );
      }}
    </AuthConsumer>
  );
};

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

const checkoutSchema = yup.object().shape({
  org_name: yup.string().required("required"),
  first_name: yup.string().required("required"),
  last_name: yup.string().required("required"),
  address: yup.string().required("required"),
  email: yup.string().email("invalid email").required("required"),
  contact: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  country: yup.string().required("required"),
  city: yup.string().required("required"),
  password2: yup
    .string()
    .min(7, "Password length should be greater than 7")
    .required("required"),
  password: yup
    .string()
    .min(7, "Password length should be greater than 7")
    .required("required"),
});
const initialValues = {
  first_name: "",
  second_name: "",

  org_name: "",
  email: "",
  contact: "",
  country: "",
  city: "",
  password: "",
  password2: "",
  address: "",
};

export default SignUpForm;
